// removed by extract-text-webpack-plugin
module.exports = {"WorkHistory":"WorkHistory__WorkHistory___itTMN","WorkHeader":"WorkHistory__WorkHeader___3cTtq"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Resume/WorkHistory/WorkHistory.css
// module id = 36
// module chunks = 0